import { CancelSelectButton } from "../buttons/CancelSelectButton";
import { ClearMeasurementsButton } from "../buttons/ClearMeasurementsButton";
import { ColorizeButton } from "../buttons/ColorizeButton";
import { GroupSelectButton } from "../buttons/GroupSelectButton";
import { LayerSelectionButton } from "../buttons/LayerSelectionButton";
import { MeasureAreaButton } from "../buttons/MeasureAreaButton";
import { MeasureDistanceButton } from "../buttons/MeasureDistanceButton";
import { PrintButton } from "../buttons/PrintButton";
import { ToggleParcelsButton } from "../buttons/ToggleParcelsButton";
import { ZoomInButton, ZoomOutButton, ZoomToSelectedButton } from "../buttons/ZoomButtons";
import { BufferSearchButton } from "../buttons/BufferSearchButton";
import { MeasureLayer } from "../layers/client/ClientLayers";
import { InspectionsLayer } from "../layers/selectable/InspectionsLayer";
import { Toolbar } from "../../lib/ui/toolbar";
import { SalesRatioLayer } from "../layers/selectable/SalesRatioLayer";
import { NhListSelectButton } from "../buttons/NhGroupSelectButton";
import { SeperatorPlaceholderButton } from "../buttons/SeperatorPlaceholderButton";
import { SalesListSelectButton } from "../buttons/SalesListSelectButton";
import { LandListSelectButton } from "../buttons/LandListSelectButton";
import { InteractionButton } from "../../lib/ui/toolbar/buttons";
import { CurrentLocationButton } from "../buttons/CurrentLocationButton";
export class GSAToolbar extends Toolbar {
    constructor(p_layer, b_layer, loc_layer) {
        super({});
        this.common_btns = [];
        this.layers_btn = new LayerSelectionButton();
        this.common_btns = [
            this.layers_btn,
            new SeperatorPlaceholderButton(),
            new ZoomOutButton(),
            new ZoomToSelectedButton(),
            new ZoomInButton(),
            new CurrentLocationButton(loc_layer),
            new SeperatorPlaceholderButton(),
            new MeasureDistanceButton(),
            new MeasureAreaButton(),
            new ClearMeasurementsButton(MeasureLayer),
            new SeperatorPlaceholderButton(),
            new BufferSearchButton(b_layer).bind('singleton', 'set', 'toolbar', 'group', 'nh', 'sale', 'land'),
            new GroupSelectButton().bind('singleton', 'set', 'toolbar', 'group', 'nh', 'sale', 'land'),
            new NhListSelectButton().bind('singleton', 'set', 'toolbar', 'group', 'nh', 'sale', 'land'),
            new SalesListSelectButton().bind('singleton', 'set', 'toolbar', 'group', 'nh', 'sale', 'land'),
            new LandListSelectButton().bind('singleton', 'set', 'toolbar', 'group', 'nh', 'sale', 'land'),
            new ColorizeButton(p_layer).bind('set'),
        ];
        let non_insp_btns = [
            new CancelSelectButton(p_layer, b_layer).bind('set', 'nh', 'sale', 'land')
        ];
        let marker_btns = [
            new ToggleParcelsButton().bind('selection', 'edit')
        ];
        let print_btns = [
            new SeperatorPlaceholderButton(),
            new PrintButton()
        ];
        let btns = [...this.common_btns];
        if (!(p_layer instanceof InspectionsLayer || p_layer instanceof SalesRatioLayer))
            btns.push(...non_insp_btns);
        this.add_buttons(...btns, ...marker_btns, ...print_btns);
        this.setup_group_interaction_cancelled_listener();
    }
    display_layers_list() {
        this.layers_btn._action();
    }
    setup_group_interaction_cancelled_listener() {
        $(document).on('group_interaction_cancelled', () => {
            this.common_btns.filter(x => x instanceof InteractionButton).forEach(x => {
                x.ui.removeClass('highlighted');
            });
        });
    }
}
